import { Label } from '@nike/eds';
import * as luxon from 'luxon';

const ourtimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
console.log("Your timezone is set to ", ourtimezone);

const parseDate = (timestamp) => {
    var dt = luxon.DateTime.fromISO(timestamp, {zone: 'UTC'});
    return dt.setZone(ourtimezone);
}

const DateTimeFormat = ({timestamp, format = "dd/MM/yyyy HH:mm:ss", font = ''}) => {
    let formatted = "";

    if (!format) {
        format = "dd/MM/yyyy HH:mm:ss";
    }

    if (timestamp) {
        const dt = parseDate(timestamp);
        formatted = dt.toFormat(format);
    }
    if (font) {
        return <Label font={font}>
            {formatted}
        </Label>
    }
    return <>{formatted}</>
};

export default DateTimeFormat;
export { parseDate };